module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-38.49079243.png";